/* eslint-disable */
import React from "react";
import RenderCalendlyLinks from "../../components/common/RenderCalendlyLinks";
import NewProductTemplate from "../../components/sections/product-more-info/Item";
import { cn } from "../../utils/cn";
import Emoji from "../../utils/emoji";
import ProductTemplate from "./product";

const Product = (props) => {
    const { pageContext } = props;
    const { item } = pageContext;

    const newProductsEnabled =
        process.env.GATSBY_NEW_PRODUCTS_ENABLED === "true";

    const Data = () => {
        return (
            <section className="mx-auto max-w-xl text-left font-inter text-gray-500 lg:max-w-2xl xl:max-w-3xl">
                <h2 className={cn(styles.title)}>
                    <Emoji symbol="🎤" label="entrevista" /> FASE 3: Simulacre
                    d’Entrevista Mossos d&apos;Esquadra Convocatòria 46/25 (maig
                    2025)
                </h2>

                <p className="mt-5">
                    El{" "}
                    <strong className="text-cpurple">
                        Simulacre d’Entrevista (Fase 3)
                    </strong>{" "}
                    és l’últim pas de la preparació abans del dia oficial. Una{" "}
                    <strong className="text-cpurple">
                        sessió individual, presencial i realista
                    </strong>
                    , pensada perquè visquis l’entrevista exactament com el dia
                    de la prova i puguis corregir errors abans que comptin.
                </p>

                <p>
                    Des del primer minut{" "}
                    <strong className="text-cpurple">
                        seràs avaluat com en l’entrevista oficial
                    </strong>
                    .
                </p>

                <h2 className={cn(styles.title, "mt-10")}>
                    <Emoji symbol="🎯" label="objectiu" /> Què és aquest
                    simulacre?
                </h2>

                <p className="mt-5">
                    És una{" "}
                    <strong className="text-cpurple">
                        simulació completa d’entrevista
                    </strong>{" "}
                    de Mossos d’Esquadra, basada en{" "}
                    <strong className="text-cpurple">
                        el model oficial de la convocatòria
                    </strong>
                    .
                </p>

                <p>Durant la sessió:</p>

                <ul className={cn(styles.list, "mt-5")}>
                    <li>
                        <strong className="text-cpurple">
                            Realitzes una entrevista en condicions reals
                        </strong>
                        .
                    </li>
                    <li>
                        <strong className="text-cpurple">
                            Se t’avalua segons les competències exigides
                        </strong>
                        .
                    </li>
                    <li>
                        <strong className="text-cpurple">
                            Reps un feedback final professional i detallat
                        </strong>
                        .
                    </li>
                </ul>

                <p className="mt-5">
                    <strong className="text-cpurple">
                        No és una classe teòrica
                    </strong>
                    : és una prova real.
                </p>

                <h2 className={cn(styles.title, "mt-10")}>
                    <Emoji symbol="🧠" label="metodologia" /> Com es treballa el
                    Nivell 3?
                </h2>

                <ul className={cn(styles.list, "mt-5")}>
                    <li>
                        <strong className="text-cpurple">Durada:</strong> 1 hora
                    </li>
                    <li>
                        <strong className="text-cpurple">Format:</strong>{" "}
                        presencial i individual
                    </li>
                </ul>

                <p className="mt-5">La sessió inclou:</p>

                <ul className={cn(styles.list, "mt-5")}>
                    <li>
                        <strong className="text-cpurple">
                            Simulacre d’entrevista basat en l’oficial
                        </strong>
                        .
                    </li>
                    <li>
                        <strong className="text-cpurple">
                            Preguntes alineades amb les competències exigides
                        </strong>{" "}
                        a la convocatòria.
                    </li>
                    <li>
                        <strong className="text-cpurple">Avaluació de:</strong>
                        <ul className="ml-5 mt-2 list-disc">
                            <li>comunicació verbal i no verbal,</li>
                            <li>coherència del discurs,</li>
                            <li>seguretat, actitud i gestió de la pressió.</li>
                        </ul>
                    </li>
                    <li>
                        <strong className="text-cpurple">
                            Feedback final amb correcció d’errors i
                            recomanacions clares
                        </strong>{" "}
                        de millora.
                    </li>
                </ul>

                <h2 className={cn(styles.title, "mt-10")}>
                    <Emoji symbol="👤" label="perfil" /> A qui va dirigit?
                </h2>

                <p className="mt-5">Aquest simulacre és ideal si:</p>

                <ul className={cn(styles.list, "mt-5")}>
                    <li>Et presentes a l’entrevista de Mossos d’Esquadra.</li>
                    <li>
                        <strong className="text-cpurple">
                            Ja has treballat el teu perfil
                        </strong>{" "}
                        i vols posar-lo a prova.
                    </li>
                    <li>Vols saber com rendiràs en una situació real.</li>
                    <li>
                        <strong className="text-cpurple">
                            Necessites detectar errors abans del dia oficial
                        </strong>
                        .
                    </li>
                </ul>

                <p className="mt-5">
                    <strong className="text-cpurple">
                        Especialment recomanat com a últim pas
                    </strong>{" "}
                    abans de l’entrevista real.
                </p>

                <h2 className={cn(styles.title, "mt-10")}>
                    <Emoji symbol="🔥" label="resum" /> En resum
                </h2>

                <p className="mt-5">
                    El{" "}
                    <strong className="text-cpurple">
                        Simulacre d’Entrevista Mossos 2025 (Fase 3)
                    </strong>{" "}
                    és una eina clau per arribar al dia oficial amb{" "}
                    <strong className="text-cpurple">
                        criteri, seguretat i sense sorpreses
                    </strong>
                    .
                </p>

                <h2 className={cn(styles.title, "mt-10")} id="reserva">
                    <Emoji symbol="📅" label="reserva" /> Reserva la teva hora!
                </h2>

                <p className="mt-5">
                    Disposem de{" "}
                    <strong className="text-cpurple">
                        diversos professors tutors especialitzats
                    </strong>{" "}
                    en l’entrevista policial, que seran els encarregats de
                    realitzar les sessions de preparació. A continuació pots
                    consultar els{" "}
                    <strong className="text-cpurple">
                        calendaris disponibles
                    </strong>{" "}
                    i <strong className="text-cpurple">reservar l’hora</strong>{" "}
                    amb el tutor que millor s’adapti a la teva disponibilitat.
                </p>

                <p className="mt-5">
                    👉{" "}
                    <strong className="text-cpurple">
                        Posa’t a prova abans que compti de veritat
                    </strong>
                    .
                </p>

                <RenderCalendlyLinks
                    stock={item.stock}
                    calendly_schedule={item.calendly_schedule}
                />
            </section>
        );
    };

    return (
        <>
            {!newProductsEnabled ? (
                <ProductTemplate item={item}>
                    <Data />
                </ProductTemplate>
            ) : (
                <NewProductTemplate
                    item={item}
                    title="Sessió personalitzada per defensar el teu perfil amb seguretat i criteri a l’entrevista de Mossos d’Esquadra."
                >
                    <Data />
                </NewProductTemplate>
            )}
        </>
    );
};

const styles = {
    strong: "font-semibold text-ccyan",
    title: "font-bold text-xl font-montserrat",
    list: "list-disc ml-4",
};

export default Product;
